import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http/api.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TipoRepresentacaoInstituicaoEnsino } from '../models/tipo-representacao-instituicao-ensino.model';

@Injectable({
  providedIn: 'root'
})
export class TipoRepresentacaoInstituicaoEnsinoService {
  private readonly path = 'bolsa';

  constructor(private apiService: ApiService) {}

  // List all TipoRepresentacaoInstituicaoEnsino
  list(): Observable<TipoRepresentacaoInstituicaoEnsino[]> {
    return this.apiService.get<{ data: TipoRepresentacaoInstituicaoEnsino[] }>(`${this.path}/getAllTipoRepresentacaoInstituicaoEnsino`).pipe(
      map(response => response.data)
    );
  }

  // Get TipoRepresentacaoInstituicaoEnsino by ID
  public show(id: string): Observable<TipoRepresentacaoInstituicaoEnsino> {
    return this.apiService.get<{ data: TipoRepresentacaoInstituicaoEnsino }>(`${this.path}/getTipoRepresentacaoInstituicaoEnsinoById/${id}`).pipe(
      map(response => response.data)
    );
  }

  // Create new TipoRepresentacaoInstituicaoEnsino
  public store(tipoRepresentacaoInstituicaoEnsino: TipoRepresentacaoInstituicaoEnsino): Observable<TipoRepresentacaoInstituicaoEnsino> {
    return this.apiService
      .post<{ object: TipoRepresentacaoInstituicaoEnsino }>(`${this.path}/AddTipoRepresentacaoInstituicaoEnsino`, tipoRepresentacaoInstituicaoEnsino)
      .pipe(
        map(response => response.object)
      );
  }

  // Update existing TipoRepresentacaoInstituicaoEnsino
  public update(tipoRepresentacaoInstituicaoEnsino: TipoRepresentacaoInstituicaoEnsino, id: string): Observable<TipoRepresentacaoInstituicaoEnsino> {
    return this.apiService
      .put<{ object: TipoRepresentacaoInstituicaoEnsino }>(`${this.path}/UpdateTipoRepresentacaoInstituicaoEnsino/${id}`, tipoRepresentacaoInstituicaoEnsino)
      .pipe(
        map(response => response.object)
      );
  }

  // Delete existing TipoRepresentacaoInstituicaoEnsino
  public delete(id: string): Observable<any> {
    return this.apiService.delete(`${this.path}/DeleteTipoRepresentacaoInstituicaoEnsinoById/${id}`);
  }
}
